/* eslint max-classes-per-file: 0 */
class CustomError extends Error {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
  }
}

class AttributeValidationError extends CustomError {}

module.exports = {
  AttributeValidationError,
};
